import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class LiveProjectApi {
  constructor(util) {
    // TODO: proforma-cloud repo is returning a project's ID as a string, it should
    // be changed to a Long, and this quick fix reverted, in FORM-1517
    _defineProperty(this, "convertJiraProjectToProject", jiraProject => ({
      ...jiraProject,
      id: parseInt(jiraProject.id, 10)
    }));
    this.util = util;
  }
  getAllProjects(isJswEnabled, isJwmEnabled) {
    return this.util.get(`/api/3/projects?isJswEnabled=${isJswEnabled}&isJwmEnabled=${isJwmEnabled}`).then(projects => projects.map(project => this.convertJiraProjectToProject(project)));
  }
}